import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { EmptyState } from '@/ui-kit/templates/EmptyState/EmptyState';

import { openModal } from '@/store/actions/core.actions';
import { TRestrictionsGroupType } from '@/store/models/restriction.model';
import { useAppSelector } from '@/hooks/redux-helpers';
import { Page } from '@/ui-kit/templates/Page';

import { IRestrictionGroupFormModalProps } from './RestrictionGroupFormModal';

export const RestrictionsGroupsPage = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const config = useAppSelector((state) => state.dashboardConfig.config);
  const { type } = useParams<{ type: TRestrictionsGroupType }>();

  const toggleRestriction = () => {
    dispatch(
      openModal<IRestrictionGroupFormModalProps>('restrictionsPredefModal', {
        restrictionsGroupType: type ?? 'mid',
        header: t('pages.administration.restrictionGroup.addModal.header'),
      }),
    );
  };

  return (
    <Page
      actions={
        config.settings.cards.restrictions?.length
          ? [
              {
                id: 'add-restriction-group-btn',
                label: t('pages.administration.restrictionGroup.addModal.header'),
                icon: 'add',
                onClick: toggleRestriction,
              },
            ]
          : []
      }
    >
      {config.settings.cards.restrictions?.length ? (
        children
      ) : (
        <EmptyState
          title={t('pages.currentProfiles.admin.restrictions.noData')}
          icon="search_v1"
          className="max-w-[400px] m-auto mt-10"
        />
      )}
    </Page>
  );
};
